import React from 'react';
import {LabelSelectedDatesProps} from './LabelSelectedDates.types';
import {
	LabelSelectedDatesLabel,
	LabelSelectedDatesOptional,
	LabelSelectedDatesWrapper,
} from './styles';

const LabelSelectedDates: React.FC<LabelSelectedDatesProps> = ({
	firstDaySelected,
	secondDaySelected,
	showOptionalLabel = false,
}) => (
	<LabelSelectedDatesWrapper>
		<LabelSelectedDatesLabel firstDaySelected={firstDaySelected}>
			{firstDaySelected ? firstDaySelected.toLocaleDateString() : 'Data inicial'}
		</LabelSelectedDatesLabel>
		<LabelSelectedDatesLabel secondDaySelected={secondDaySelected}> - </LabelSelectedDatesLabel>
		<LabelSelectedDatesLabel secondDaySelected={secondDaySelected}>
			{secondDaySelected ? secondDaySelected.toLocaleDateString() : 'Data final'}
		</LabelSelectedDatesLabel>
		{showOptionalLabel ? (
			<LabelSelectedDatesOptional> (opcional) </LabelSelectedDatesOptional>
		) : null}
	</LabelSelectedDatesWrapper>
);

export {LabelSelectedDates};
